<template>
   <v-tooltip top>
      <template v-slot:activator="{ on }">
         <IconBtn v-model="printMode"
          :icons="icon"
          @click="changePrintMode"
          v-on="on" />
      </template>
      <span>{{ tooltip }}</span>
   </v-tooltip>
</template>

<script>
import IconBtn from "./IconBtn.vue";

export default {
  components: {
    IconBtn,
  },
  props: {
    tooltipText: String,
  },
  data() {
    return {
      printMode: false,
    };
  },
  computed: {
    icon() {
      if (this.printMode) {
        return "view_agenda";
      } else {
        return "print";
      }
    },
    tooltip() {
      if (this.printMode) {
        return this.tooltipText;
      } else {
        return "Режим друку";
      }
    },
  },
  methods: {
    changePrintMode() {
      this.printMode = !this.printMode;
      this.$emit("click");
    },
  },
};
</script>